import React, { PropsWithChildren } from 'react';

import { ControlGroupProps } from './models';
import styles from './styles.module.scss';

const ControlGroup: React.FunctionComponent<PropsWithChildren<ControlGroupProps>> = ({ children, dataTestId = 'controlGroup' }) => (
  <div className={styles.ControlGroup} data-testid={dataTestId}>{children}</div>
);

export default ControlGroup;
